// ProjectCard.js
import React from 'react';
import Tilt from 'react-parallax-tilt';
import { useSpring, animated, useInView } from 'react-spring';
import GitHubIcon from '@mui/icons-material/GitHub';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
const ProjectCard = ({ project, index }) => {
  const [ref, inView] = useInView({
    threshold: 0.7, // Trigger animation when 50% of the component is in the viewport
  });
  const textstyle = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0)' : `translateX(${index % 2 !== 0 ? '80px' : '-80px'})`,
    delay: 150
  })
  return (

    <div className={`project-card${index % 2 !== 0 ? 'right' : ""}`} >
      <a href={project.link} target='_blank'>
        <Tilt
          tiltAxis='y'
          options={{
            max: 20,
            scale: 0.5,
            speed: 30,
          }}

        >
          <img src={require(`../assets/${project.image}`)} alt={project.title} className="project-image" />
        </Tilt>
      </a>
      <animated.div ref={ref} style={textstyle}>
        <h3 className="project-title">{project.id}. {project.title}</h3>
        <div className='project-text'>
          <div className="project-tags">
            {
              project.tech.map((t) => <span className='tech'>{t}</span>
              )
            }
          </div>
          <p className="project-description">{project.description}</p>
          <div className={`link${index % 2 !== 0 ? 'right' : ""}`}>
            <a href={project.github} target='_blank' ><GitHubIcon sx={{ color: 'white' }} /></a>
            {project.link && <a href={project.link} target='_blank' ><OpenInNewIcon sx={{ color: 'white' }} /></a>}
          </div>
        </div>
      </animated.div>
    </div>
  );
};

export default ProjectCard;
